import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocation, faStethoscope,faBolt ,faPlug,faBug,faGears} from '@fortawesome/free-solid-svg-icons'

import {issueMatchingObj, conIdMatchingObj} from '../helper'

import BatteryImage from './BatteryImage'

function Battery({battery}) {


    //time ago 
    let time = new Date(battery.lastConnectionTime)
    /* const batte = {
      id : 'BA-S2', 
      location:'PORT',
      voltage:20,
      capacity:30,
      connectionStatus:2,
      stateOfHealth:3,
      stateOfCharge:87,
      lastConnectionTime:'01-07-2022T0202',
      recentIssues:['Anomaly']
    } */
  
  return (
    <>
        {
          <h4>Id : {battery && battery.id}</h4>  
            
        }
        <div className='App-battery-items'>
          <div>
            <ul>
              <li> {<FontAwesomeIcon icon={faLocation} />} Location  : {battery.location} </li>
              <li>{<FontAwesomeIcon icon={faBolt} />} Voltage : {battery.voltage} v </li>
              <li>{<FontAwesomeIcon icon={faGears} />} Capacity : {battery.capacity} A.h</li>
              
            </ul>
          </div>
          {battery &&<BatteryImage battery={battery}/>}
        <div>
          <ul>
            <li> {<FontAwesomeIcon icon={faPlug} />} Connection Status : {battery.connectionStatus ? conIdMatchingObj[battery.connectionStatus] : 'N/A'} </li>
            <li> {<FontAwesomeIcon icon={faStethoscope} />} Health State : {battery.stateOfHealth ? battery.stateOfHealth : 'N/A'}</li>
            <li> {<FontAwesomeIcon icon={faBug} />} Recent Issues : {battery.recentIssues[0] ? battery.recentIssues.map(issue => issueMatchingObj[issue] + ', ') : 'N/A'}</li>
          </ul>
        </div>

       </div>
        <p> Last connection time : 
           {time.toUTCString()}
        </p>
        
        
    </>
  )
}

export default Battery